module.exports = __webpack_public_path__ + "img/accessory_shirt_14.aa93ea9f.svg";